import {doPost, doGet} from './Base';


const getDomains = async () => {
    return await doGet('/domains');
};


const checkDomain = async (domain) => {
  return await doPost('/domains/' + domain.domain + '/check');
};


const createDomain = async (domain) => {
  return await doPost('/create_domain', {domain: domain});
};


export {getDomains, checkDomain, createDomain};
export default getDomains;
